module.exports = __webpack_public_path__ + "img/account.4c74d087.png";